export const brand = {
  new: 'customerEndpoint/landingPages',
};
